import { fetchData } from './fetchData';

export interface VirtualBankAccount {
  id?: number;
  account_number: string;
  balance?: string;
  currency_code: string;
  currency_name?: string;
  has_transactions?: boolean;
  name: string;
  owner?: boolean;
}

export async function fetchVirtualBanks(orgId: string) {
  return await fetchData<{ data: VirtualBankAccount[] }>(
    `/api/v2/documentation/organisations/${orgId}/virtual_bank_accounts`,
    'GET',
    {}
  );
}
